import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Navbar } from './Navbar'

export function DashboardLayout() {
  return (
    <div className="min-h-screen bg-paper">
      <Sidebar />
      <div className="flex flex-col lg:pl-72">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <footer className="border-t border-ink-100 px-6 py-4 text-center text-xs text-ink-500">
          © {new Date().getFullYear()} Radiance Dental Clinic · Built with care in Madurai
        </footer>
      </div>
    </div>
  )
}
